import { cva, type VariantProps } from 'class-variance-authority';

export const inputVariants = cva(
  'w-full min-w-0 border border-line bg-surface-2 text-ink transition-tone placeholder:text-muted disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-danger',
  {
    variants: {
      size: {
        md: 'h-10 rounded-control px-3',
        lg: 'h-12 rounded-control-lg px-3.5',
      },
      isMono: { true: 'font-mono text-control', false: '' },
    },
    defaultVariants: { size: 'md', isMono: false },
  },
);

export type InputVariants = VariantProps<typeof inputVariants>;
